import { createStory } from './create'
import { readStories } from './read'

export const stories = {
  createSingle: createStory,
  read: readStories,
}
